import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs';
import {
  CreateOrUpdateUserDailyValueOfPurchaseAlertSettingCommand,
  GetEnumValuesDto,
  NotificationImportanceLevel,
} from 'src/app/core/api/models';
import { UserDailyValueOfPurchaseAlertSettingService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  BaseFormModule,
  BaseFormPageComponent,
} from 'src/app/pages/shared/base';
import { AlertSettingComponent } from './alert-setting/alert-setting.component';

@Component({
    selector: 'app-value-of-purchase-alert-setting-form',
    templateUrl: './value-of-purchase-alert-setting-form.component.html',
    imports: [BaseFormModule, AlertSettingComponent]
})
export class ValueOfPurchaseAlertSettingFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() model: CreateOrUpdateUserDailyValueOfPurchaseAlertSettingCommand =
    {};

  get notificationImportanceLevel() {
    return NotificationImportanceLevel;
  }
  NotificationImportanceLevelEnumValues: GetEnumValuesDto[] = [];
  notificationImportanceLevelLoading: boolean = false;
  //#endregion

  constructor(
    protected currentService: UserDailyValueOfPurchaseAlertSettingService
  ) {
    super();
  }

  //#region init methods
  ngOnInit(): void {
    super.ngOnInit();
    this.getEnumsValues();
    this.formPageConfig.isEditMode = true;
  }

  getEnumsValues() {
    this.notificationImportanceLevelLoading = true;
    this.getEnumValuesApi('NotificationImportanceLevel')
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.notificationImportanceLevelLoading = false))
      )
      .subscribe(
        (values) => (this.NotificationImportanceLevelEnumValues = values)
      );
  }

  initForm() {
    this.form = new FormGroup({
      daysOfSendFrequencyPeriod: new FormControl(''),
      isEnableSendNotification: new FormControl(''),
      generalInformation: new FormGroup({
        importanceLevel: new FormControl(''),
        fromDaysMoreThanSendFrequently: new FormControl(''),
        toDaysMoreThanSendFrequently: new FormControl(''),
      }),
    });
  }

  //#endregion

  //#region Api

  //Update
  baseUpdateApi(
    model: CreateOrUpdateUserDailyValueOfPurchaseAlertSettingCommand
  ) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .userDailyValueOfPurchaseAlertSettingCreateOrUpdate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getItems(value) {
    this.model.importanceLevels = this.model.importanceLevels.filter(
      (item) => item.importanceLevel != value.importanceLevel
    );
    this.model.importanceLevels.push(value);
    this.model.importanceLevels.sort(
      (a, b) => a.importanceLevel - b.importanceLevel
    );
  }
}
